<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <div class="legend-page">
    <!-- Header: logo + title + bottom border -->
    <div class="legend-header">
      <img src="@/assets/img/black-logo.svg" alt="On" class="legend-logo" />
      <span class="legend-title">{{ t('seasonCatalogPdf.legend.title') }}</span>
    </div>

    <!-- Content: two columns -->
    <div class="legend-content">
      <div>
        <p class="section-title">{{ t('seasonCatalogPdf.legend.general_information') }}</p>
        <ul class="legend-list">
          <li>
            <img src="@/assets/img/icons/size_icon.svg" alt="" />
            <p>{{ t('seasonCatalogPdf.legend.size') }}</p>
          </li>
          <li>
            <img src="@/assets/img/icons/weight_icon.svg" alt="" />
            <p>{{ t('seasonCatalogPdf.legend.weight') }}</p>
          </li>
          <li>
            <img src="@/assets/img/icons/heel_to_toe_offset_icon.svg" alt="" />
            <p>{{ t('seasonCatalogPdf.legend.heel_to_toe_offset') }}</p>
          </li>
        </ul>
      </div>
      <div>
        <p class="section-title">{{ t('seasonCatalogPdf.legend.labels_on_product') }}</p>
        <ul class="legend-list">
          <li>
            <img src="@/assets/img/icons/new_icon.svg" alt="" />
            <p>{{ t('seasonCatalogPdf.legend.new') }}</p>
          </li>
          <li>
            <img src="@/assets/img/icons/preorder_only_icon.svg" alt="" />
            <p>{{ t('seasonCatalogPdf.legend.preorder_only') }}</p>
          </li>
          <li>
            <img src="@/assets/img/icons/icon_key_item.svg" alt="" />
            <p>{{ t('seasonCatalogPdf.legend.key_item') }}</p>
          </li>
          <li>
            <img src="@/assets/img/icons/icon_carry_over_next_season.svg" alt="" />
            <p>{{ t('seasonCatalogPdf.legend.carry_over') }}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.legend-page {
  width: 297mm;
  height: 210mm;
  padding: 1rem;
  background-color: var(--pdf-background-light-color);
  page-break-after: always;
  overflow: hidden;

  .legend-header {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 16px 40px;
    border-bottom: 1px solid var(--border-inactive-color);

    .legend-logo {
      width: 32px;
      height: 32px;
    }

    .legend-title {
      font-size: 1.5rem;
      color: var(--primary-dark);
    }
  }

  .legend-content {
    padding: 30px 40px 0;
    display: flex;
    flex-direction: column;
    row-gap: 1.5rem;

    .section-title {
      font-size: 1.25rem;
      font-weight: bold;
      color: var(--primary-dark);
      margin: 0 0 10px;
      text-align: left;
    }

    .legend-list {
      list-style: none;
      padding: 0;
      margin: 0 0 20px;

      li {
        display: flex;
        align-items: center;
        gap: 20px;
        margin-bottom: 5px;

        img {
          width: 24px;
          height: 24px;
          flex-shrink: 0;
        }
      }
    }
  }
}
</style>
